import React from "react"
import { Card, CardBody, Row, Col } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { useSelector } from "react-redux"

const RatingPerDayCard = ({ reviews = [], avgRating = 0, chartOptions }) => {
  const mode = useSelector(state => state.Layout.layoutMode)
  return (
    <Card
      style={{
        marginTop: "20px",
        borderRadius: "20px",
      }}
    >
      <CardBody>
        <h4
          className={`card-title mb-4 ${mode === "dark" ? "dark-text" : "light-text"}`}
        >
          Rating Per Day
        </h4>

        <Row className="text-center mt-4">
          <Col xs="6">
            <h5 className="font-size-20">{reviews.length}</h5>
            <p className="text-muted">Total Reviews</p>
          </Col>
          <Col xs="6">
            <h5 className="font-size-20">
              {avgRating ? avgRating.toFixed(2) : 0}
            </h5>
            <p className="text-muted">Average Rating</p>
          </Col>
        </Row>

        <div
          id="rating-bar-chart"
          className="morris-charts morris-charts-height"
          dir="ltr"
        >
          <ReactApexChart
            options={{
              ...chartOptions.options,
              colors: ["#2990DF"],
            }}
            series={chartOptions.series}
            type="bar"
            height="290"
          />
        </div>
      </CardBody>
    </Card>
  )
}

export default RatingPerDayCard
